import React, { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { API_BASE_URL } from "../../ApiConfig";
import { getSecureToken, searchCompanies } from "../../ApisService/apiService";
import ScreenerData from "./Scanerdata";
import style from "../../../css/admin/Workshopupload.module.css"; // Importing CSS module
import { showCustomAlert } from "../../customalert";

const ScanerUpload = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedStrategy, setSelectedStrategy] = useState(""); // State for strategy

  // Available strategies
  const strategies = ["VPC SETUP", "ROCKET BASE", "IPO BASE", "FNO SETUP"];

  const handleSearch = async (event) => {
    const searchQuery = event.target.value;
    setQuery(searchQuery);

    if (searchQuery.length < 2) {
      setResults([]);
      return;
    }

    setLoading(true);
    try {
      const filteredResults = await searchCompanies(searchQuery);
      setResults(filteredResults);
    } catch (error) {
      console.error("Error searching companies:", error);
    }
    setLoading(false);
  };

  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
    setQuery("");
    setResults([]);
  };

  const handleSave = async () => {
    if (!selectedCompany) return alert("Please select a company first.");
    if (!selectedStrategy) return alert("Please select a strategy.");

    try {
      const payload = {
        name: selectedCompany.companyname || selectedCompany.scripname,
        code: selectedCompany.scripcode,
        symbol: selectedCompany.symbol,
        industry: selectedCompany.industry || "N/A",
        strategy: selectedStrategy,
      };
      const { secrettoken, ts } = await getSecureToken();

      const response = await axios.post(`${API_BASE_URL}Screener/Screener_save.php`, payload, {
          headers: {
            'X-TOKEN': secrettoken,
            'X-TIMESTAMP': ts,
          },
        withCredentials: true,
      });

      console.log(response);

      if (response.data.success) {
        showCustomAlert("Company data and strategy saved successfully!");
        setSelectedCompany(null);
        setSelectedStrategy(""); // Reset strategy
        setModalOpen(false);
        window.location.reload();
      } else {
        showCustomAlert("Failed to save company data.");
      }
    } catch (error) {
      console.error("Error saving company:", error);
      alert("Failed to save company data.");
    }
  };

  return (
    <>
      <div className={style.uploadContainer}>
        {/* Upload Company Button */}
        <button className={style.uploadButton} onClick={() => setModalOpen(true)}>
          <i className="fa-solid fa-cloud-arrow-up"></i> Company screener
        </button>

        {/* Modal for Searching and Saving Company */}
        {isModalOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className={style.modalOverlay}
          >
            <div className={style.modalContent}>
              <h3 className={style.modalTitle}>Search & Save Company</h3>
              <form className={style.uploadForm}>
                <input
                  type="text"
                  value={query}
                  onChange={handleSearch}
                  placeholder="Search company name, symbol, or scrip name..."
                />
              </form>
              {loading && <p className={style.loadingText}>Loading...</p>}

              {results.length > 0 && (
                <ul className={style.resultList}>
                  {results.map((company) => (
                    <li
                      key={company.scripcode}
                      className={style.resultItem}
                      onClick={() => handleSelectCompany(company)}
                    >
                      {company.scripname} ({company.SYMBOL} - {company.scripcode})
                    </li>
                  ))}
                </ul>
              )}

              {selectedCompany && (
                <div className={style.selectedCompany}>
                  <h4>{selectedCompany.companyname}</h4>
                  <p><strong>Code:</strong> {selectedCompany.scripcode}</p>
                  <p><strong>Symbol:</strong> {selectedCompany.symbol}</p>
                  <p><strong>Industry:</strong> {selectedCompany.industry || "N/A"}</p>


                  {/* Strategy Selector */}
                  <div className={style.strategySelector}>
                    <label htmlFor="strategy">Select Strategy:</label>
                    <select
                      id="strategy"
                      value={selectedStrategy}
                      onChange={(e) => setSelectedStrategy(e.target.value)}
                    >
                      <option value="">-- Select Strategy --</option>
                      {strategies.map((strategy, index) => (
                        <option key={index} value={strategy}>{strategy}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div className={style.modalActions}>
                <button onClick={handleSave} className={style.saveButton}>Save</button>
                <button onClick={() => setModalOpen(false)} className={style.deleteButton}>Cancel</button>
              </div>
            </div>
          </motion.div>
        )}
      </div>

      <ScreenerData />
    </>
  );
};

export default ScanerUpload;
